import React, { useState, useEffect } from "react";
import { Form, Input, Button, Typography, Row, Col, Spin, message, Card } from "antd";
import { useHistory } from "react-router-dom";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
import { routes } from "../../../routes/Routes";
import { RightOutlined, UserOutlined, IdcardOutlined, EditOutlined } from '@ant-design/icons';
import { COMMON_ERROR_MSG } from "../../../constants/constants";
import moment from "moment";
import _commonService from "../../../modules/commonService";
import _capitalProviderService from "../../../modules/capitalProviderService";

const { Title, Text } = Typography;

const CapitalProviderProfile = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [LoanOfficerInfo, setLoanOfficerInfo] = useState({});
    const capitalProviderUserId = localStorage.getItem("capitalProviderUserId");
    const capitalProviderFirstName = localStorage.getItem("capitalProviderFirstName");

    useEffect(() => {
        getLoanOfficerInformationByLoanOfficerId();
    }, []);

    const getLoanOfficerInformationByLoanOfficerId = async () => {
        try {
            setLoading(true);
            const res = await _capitalProviderService.getLoanOfficerInformationByLoanOfficerId(capitalProviderUserId);
            if (res?.data?.IsSuccess && res.data.Obj) {
                setLoading(false);
                setLoanOfficerInfo(res.data.Obj);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error fetching banker information:", error);
        }
    };


    const onFinish = async (values) => {
        //history.push(routes.accountLogin.path);
        setLoading(true);
        try {
            const reqObj = {
                Email: LoanOfficerInfo.Email,
                OldPassword: values.currentPassword,
                NewPassword: values.newPassword,
                ConfirmPassword: values.confirmPassword,
            }
            const res = await _capitalProviderService.ChangeLoanOfficerPassword(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                form.resetFields();
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
        } finally {
            setLoading(false);

        }
    };

    const validatePassword = (_, value) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@%&!^*.,_+=?]).{8,20}$/;
        if (!value || passwordRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            new Error(
                "Password must include uppercase, lowercase, number, special character and be 8-20 characters long"
            )
        );
    };
    const onPersonalEditClick = () => {
        history.push({
            pathname: routes.capitalProviderPersonalDetails.path,
            state: { capitalProviderUserId: localStorage.getItem("capitalProviderUserId"), isFromDashboard: true, },
        });
    }
    const onProfessionalEditClick = () => {
        history.push({
            pathname: routes.capitalProviderProfessionalDetails.path,
            state: { capitalProviderUserId: localStorage.getItem("capitalProviderUserId"), isFromDashboard: true, },
        });
    }
    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                <Title level={4}>Hello, {capitalProviderFirstName}!</Title>
                <Row gutter={[16, 16]}>
                    <Col xs={24} lg={12}>
                        <Card style={{ borderRadius: 12, width: "100%", height: "100%" }}
                            title={
                                <Row justify="space-between" align="middle" className="balance-heading">
                                    <Text strong>
                                        <span role="img" aria-label="user" style={{ marginRight: 2 }}><UserOutlined /> </span>
                                        Personal Details
                                    </Text>
                                    <EditOutlined onClick={onPersonalEditClick} style={{ color: "#595959", cursor: "pointer" }} />
                                </Row>
                            }
                        >
                            <Row gutter={[12, 12]}>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary" className="color">Account Type:</Text>
                                    <br />
                                    <Text className="b-bottm">Loan Officer</Text>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary" className="color">Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.FirstName}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Middle Initial:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.MiddleInitial || "N/A"}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Last Name:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.LastName}</Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Joined In</Text>
                                    <br />
                                    <Text className="b-bottm">
                                        {LoanOfficerInfo?.CreatedDate
                                            ? moment(LoanOfficerInfo.CreatedDate).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Date Of Birth:</Text>
                                    <br />
                                    <Text className="b-bottm">
                                        {LoanOfficerInfo?.DateOfBirth
                                            ? moment(LoanOfficerInfo.DateOfBirth).format("MM/DD/YYYY")
                                            : "N/A"}
                                    </Text>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Phone:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo?.ContactNumber ? _commonService.formatUSPhoneNumber(LoanOfficerInfo.ContactNumber) : "N/A"}</Text>
                                </Col>

                                <Col xs={24} sm={12} md={12} lg={12}>
                                    <Text type="secondary">Email:</Text>
                                    <br />
                                    <Text className="b-bottm">{LoanOfficerInfo.Email}</Text>
                                </Col>
                            </Row>
                        </Card>
                    </Col>

                    <Col xs={24} lg={12}>
                        <Card style={{ borderRadius: 12, width: "100%", height: "100%" }}
                            title={
                                <Row justify="space-between" align="middle" className="balance-heading">
                                    <Text strong>
                                        <span role="img" aria-label="user" style={{ marginRight: 2 }}><IdcardOutlined /> </span>
                                        Professional Details
                                    </Text>
                                    <EditOutlined onClick={onProfessionalEditClick} style={{ color: "#595959", cursor: "pointer" }} />
                                </Row>
                            }
                        >

                            <Row gutter={[24, 24]} align="top">
                                <Col xs={24} md={24}>
                                    <Row gutter={[0, 16]}>
                                        <Col span={12}><Text type="secondary">Job Role:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.JobRole}</Text></Col>

                                        <Col span={12}><Text type="secondary">Institution Name:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.InstitutionName}</Text></Col>

                                        <Col span={12}><Text type="secondary">Street Address:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.OfficeAddress}</Text></Col>

                                        <Col span={12}><Text type="secondary">City:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.City}</Text></Col>

                                        <Col span={12}><Text type="secondary">State:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.State}</Text></Col>

                                        <Col span={12}><Text type="secondary">Zip Code:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.ZipCode}</Text></Col>

                                        {/* <Col span={12}><Text type="secondary">ID Number:</Text></Col>
                                        <Col span={12}><Text className="b-bottm">{LoanOfficerInfo.IdentificationNumber}</Text></Col> */}
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                <Row justify="center" style={{ marginTop: 25 }}>
                    <Col xs={24} md={12} style={{ display: "flex" }}>
                        <Card style={{ borderRadius: 12, width: "100%", height: "100%" }} className="consumerUserProfile">
                            <Title level={5} style={{ fontSize: "18px", textAlign: "left", marginBottom: 16 }}>Change Password</Title>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                                requiredMark={true}
                            >
                                <Form.Item
                                    label="Current Password"
                                    name="currentPassword"
                                    rules={[{ required: true, message: "Current Password is required" }]}
                                >
                                    <Input.Password maxLength={20} placeholder="Enter Current Password" />
                                </Form.Item>

                                <Form.Item
                                    label="New Password"
                                    name="newPassword"
                                    rules={[
                                        { required: true, message: "New Password is required" },
                                        { validator: validatePassword }
                                    ]}
                                >
                                    <Input.Password maxLength={20} placeholder="Enter New Password" />
                                </Form.Item>

                                <Form.Item
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    dependencies={["newPassword"]}
                                    rules={[
                                        { required: true, message: "Confirm Password is required" },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue("newPassword") === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error("Passwords do not match"));
                                            }
                                        })
                                    ]}
                                >
                                    <Input.Password maxLength={20} placeholder="Enter Confirm Password" />
                                </Form.Item>

                                <Form.Item style={{ marginTop: 32, textAlign: "center" }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        shape="round"
                                    >
                                        Submit <RightOutlined />
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </SidebarLayoutConsumer>
        </Spin>
    );
};

export default CapitalProviderProfile;